const USER_INPUT_CLASS = 'mc-user-input';

export { USER_INPUT_CLASS };
